<template>
  <div class="EventOccasionsList">
    <transition-group
      ref="occasionList"
      :style="{height: componentHeight + 'px'}"
      class="EventOccasionsList__list"
      name="slide-fade"
      tag="ul"
    >
      <EventOccasion
        v-for="eventOccasion in slicedOccasionList"
        :key="eventOccasion.id"
        ref="eventOccasion"
        :occasionData="eventOccasion"
      />
    </transition-group>

    <div class="EventOccasionsList__show-more">
      <button
        v-if="filteredOccasionList.length > 5"
        class="button button--show-occasions"
        @click="toggle">
        <svg :class="{flip: !shortList}" class="icon arrow" fill="none" height="5" viewBox="0 0 9 5" width="9"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.49294 4.99831C4.343 4.99864 4.19769 4.94054 4.08223 4.83411L0.231828 1.26453C0.100775 1.14335 0.0183608 0.969215 0.0027155 0.780437C-0.0129298 0.591658 0.0394754 0.403697 0.148402 0.257904C0.257329 0.11211 0.413856 0.020426 0.583547 0.00302095C0.753238 -0.0143841 0.922194 0.0439153 1.05325 0.165095L4.49294 3.36344L7.93264 0.279322C7.99828 0.22002 8.07381 0.175734 8.15488 0.149011C8.23596 0.122288 8.32098 0.113654 8.40507 0.123605C8.48915 0.133557 8.57064 0.161897 8.64485 0.206998C8.71906 0.252099 8.78452 0.313071 8.83748 0.386409C8.89625 0.459815 8.94076 0.545932 8.96822 0.639365C8.99568 0.732798 9.0055 0.831533 8.99707 0.929385C8.98864 1.02724 8.96213 1.1221 8.91921 1.20802C8.87629 1.29395 8.81788 1.36908 8.74764 1.42873L4.89723 4.87695C4.77846 4.96655 4.63611 5.00928 4.49294 4.99831Z"
            fill="white"/>
        </svg>
        <span v-if="shortList">
          {{ translations.showAnother }} {{ filteredOccasionList.length - 5 }} {{ translations.occasions }}
        </span>
        <span v-else>{{ translations.showLess }}</span>
        <svg :class="{flip: !shortList}" class="icon arrow" fill="none" height="5" viewBox="0 0 9 5" width="9"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.49294 4.99831C4.343 4.99864 4.19769 4.94054 4.08223 4.83411L0.231828 1.26453C0.100775 1.14335 0.0183608 0.969215 0.0027155 0.780437C-0.0129298 0.591658 0.0394754 0.403697 0.148402 0.257904C0.257329 0.11211 0.413856 0.020426 0.583547 0.00302095C0.753238 -0.0143841 0.922194 0.0439153 1.05325 0.165095L4.49294 3.36344L7.93264 0.279322C7.99828 0.22002 8.07381 0.175734 8.15488 0.149011C8.23596 0.122288 8.32098 0.113654 8.40507 0.123605C8.48915 0.133557 8.57064 0.161897 8.64485 0.206998C8.71906 0.252099 8.78452 0.313071 8.83748 0.386409C8.89625 0.459815 8.94076 0.545932 8.96822 0.639365C8.99568 0.732798 9.0055 0.831533 8.99707 0.929385C8.98864 1.02724 8.96213 1.1221 8.91921 1.20802C8.87629 1.29395 8.81788 1.36908 8.74764 1.42873L4.89723 4.87695C4.77846 4.96655 4.63611 5.00928 4.49294 4.99831Z"
            fill="white"/>
        </svg>
      </button>

    </div>
  </div>
</template>

<script>
import EventOccasion from "./EventOccasion"

export default {
  name: "EventOccasionList",
  components: {EventOccasion},
  comments: {EventOccasion},
  props: {
    eventOccasionsList: {
      type: Array
    },
    hideSoldOut: {
      type: Boolean
    }
  },
  data() {
    return {
      translations: {
        showAnother: Drupal.t('Show another'),
        showLess: Drupal.t('Show less'),
        occasions: Drupal.t('occasions'),
      },
      componentHeight: 86,
      shortList: true
    }
  },
  created() {
    this.updateComponentHeight();
    window.addEventListener("resize", this.updateComponentHeight);
  },
  methods: {
    updateComponentHeight() {
      this.$nextTick(function () {
        let height = 0;
        if (this.$refs.eventOccasion) {
          this.$refs.eventOccasion.forEach((item, index) => {
            if (index <= this.slicedOccasionList.length) {
              height += item.$el.clientHeight
            }
          })
          this.componentHeight = height;
        }
      })
    },
    toggle() {
      this.shortList = !this.shortList;
      this.updateComponentHeight();
    }
  },
  computed: {
    filteredOccasionList() {
      return this.eventOccasionsList.filter(eventOccasion => {
        return this.hideSoldOut ? !eventOccasion.soldOut : eventOccasion;
      })
    },
    slicedOccasionList() {
      return this.shortList ? this.filteredOccasionList.slice(0, 5) : this.filteredOccasionList;
    },
  }
}
</script>

<style lang="scss">
.EventOccasionsList__list {
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  transition: height .2s ease-in-out;
}

.EventOccasionsList__show-more {
  margin: 20px 0;
  text-align: center;
}

.slide-fade-enter-active {
  transition: all .3s ease-in-out;
}

.slide-fade-leave-active {
  transition: all .2s ease-in-out;
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>
